import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DeleteConfirmationData {
  description: string;
  residentName: string;
  instanceCount: number;
  dateRange: string;
  isLoading?: boolean;
}

@Component({
  selector: 'app-worklog-delete-confirmation-dialog',
  templateUrl: './worklog-delete-confirmation-dialog.component.html',
  styleUrls: ['./worklog-delete-confirmation-dialog.component.scss']
})
export class WorklogDeleteConfirmationDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<WorklogDeleteConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteConfirmationData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  updateData(newData: Partial<DeleteConfirmationData>): void {
    Object.assign(this.data, newData);
  }
}
